import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { apiClient } from '../../utils/apiHelper';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SuppliersReport = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [summary, setSummary] = useState({ total: 0, totalBalance: 0, active: 0 });

  useEffect(() => { fetchSuppliers(); }, []);

  const fetchSuppliers = async () => {
    try {
      const response = await apiClient.get('/api/accounts/suppliers');
      const data = Array.isArray(response.data) ? response.data : response.data;
      setSuppliers(data);
      const totalBalance = data.reduce((sum, s) => sum + s.balance, 0);
      const active = data.filter(s => s.is_active).length;
      setSummary({ total: data.length, totalBalance, active });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="p-6 space-y-6">
      <Card>
        <CardHeader><CardTitle>Suppliers Report</CardTitle></CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="p-4 bg-blue-50 rounded-lg">
              <p className="text-sm text-gray-600">Total Suppliers</p>
              <p className="text-2xl font-bold text-blue-600">{summary.total}</p>
            </div>
            <div className="p-4 bg-green-50 rounded-lg">
              <p className="text-sm text-gray-600">Active Suppliers</p>
              <p className="text-2xl font-bold text-green-600">{summary.active}</p>
            </div>
            <div className="p-4 bg-red-50 rounded-lg">
              <p className="text-sm text-gray-600">Total Outstanding</p>
              <p className="text-2xl font-bold text-red-600">₹{summary.totalBalance.toFixed(2)}</p>
            </div>
          </div>

          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b">
                <th className="text-left p-3">Supplier Name</th>
                <th className="text-left p-3">Company</th>
                <th className="text-left p-3">Phone</th>
                <th className="text-left p-3">Email</th>
                <th className="text-left p-3">Balance Due</th>
                <th className="text-left p-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {suppliers.length === 0 ? (
                <tr><td colSpan="6" className="text-center p-4 text-gray-500">No suppliers found.</td></tr>
              ) : (
                suppliers.map((supplier) => (
                  <tr key={supplier.id} className="border-b hover:bg-gray-50">
                    <td className="p-3 font-medium">{supplier.supplier_name}</td>
                    <td className="p-3">{supplier.company_name || '-'}</td>
                    <td className="p-3">{supplier.phone}</td>
                    <td className="p-3">{supplier.email || '-'}</td>
                    <td className="p-3 font-semibold text-red-600">₹{supplier.balance.toFixed(2)}</td>
                    <td className="p-3">
                      <span className={`px-2 py-1 text-xs rounded-full ${supplier.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
                        {supplier.is_active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
};

export default SuppliersReport;